import axiosInstance from '../axiosInstance';
import { getManagerRoutePath } from '../managerRouteUtil';

/**
 * Manager Reminders Service
 * Routes dynamically based on role_id from localStorage user.role.id
 */

const reminderService = {
  /**
   * List reminders. params: { status?: 'pending'|'all'|'completed', limit?: number }
   */
  getReminders: async (params = {}) => {
    try {
      const routePath = getManagerRoutePath();
      const response = await axiosInstance.get(`/${routePath}/reminders`, { params });
      return response.data;
    } catch (error) {
      console.error('Error fetching reminders:', error);
      throw error;
    }
  },

  /**
   * Create a custom reminder.
   */
  createReminder: async (reminderData) => {
    try {
      const routePath = getManagerRoutePath();
      const response = await axiosInstance.post(`/${routePath}/reminders`, reminderData);
      return response.data;
    } catch (error) {
      console.error('Error creating reminder:', error);
      throw error;
    }
  },

  /**
   * Mark a reminder as completed.
   */
  completeReminder: async (reminderId) => {
    try {
      const routePath = getManagerRoutePath();
      const response = await axiosInstance.patch(`/${routePath}/reminders/${reminderId}/complete`);
      return response.data;
    } catch (error) {
      console.error('Error completing reminder:', error);
      throw error;
    }
  },

  /**
   * Remove / dismiss a reminder.
   */
  deleteReminder: async (reminderId) => {
    try {
      const routePath = getManagerRoutePath();
      const response = await axiosInstance.delete(`/${routePath}/reminders/${reminderId}`);
      return response.data;
    } catch (error) {
      console.error('Error deleting reminder:', error);
      throw error;
    }
  },
};

export default reminderService;
